import React, { Suspense } from 'react';
import { Routes, Route } from "react-router";
import Loading from "@components/page/Loading";

//Layouts
import Layout from "@components/page/main/Layout";

//routes
import { mainRoutes } from "./mainRoutes";

const Index = () => {	
    return (
        <React.Fragment>
			<Suspense fallback={<Loading />}>
				<Routes>
					<Route>
						{mainRoutes.map((route, idx) => (
							<Route
								path={route.path}
								element={
									<Layout>
										{<route.component />}
									</Layout>
								}
								key={idx}
								exact={true}
							/>
						))}
					</Route>
				</Routes>
			</Suspense>
        </React.Fragment>
    );
};

export default Index;